import { createSlice } from "@reduxjs/toolkit";

const initialAssetDisposalState = {
    listLoading: false,
    actionsLoading: null,
    totalCount: 0,
    entities: null,
    roles: null,
    centers: null,
    userStatusTypes: null,
    userForEdit: undefined,
    lastError: null,
    userForRead: false,
    assignmentList: [],
};


export const callTypes = {
    list: "list",
    action: "action",
};

export const AssetDisposalSlice = createSlice({
    name: "AssetAssignment",
    initialState: initialAssetDisposalState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },

        assetRegisterFetched: (state, action) => {


            const entities = action.payload.data?.data.rows;

            const totalResult = action.payload.data?.data.totalResults;
            // const updatedEntities = entities.map(entity => {

            //     const basis_of_gratuity = entity.basis_of_gratuityId === 0 ? 'Gross' : 'Basis';


            //     return {
            //         ...entity,
            //         basis_of_gratuity // Add the new field to the entity
            //     };
            // });

            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalResult;

        },

        //get User By ID
        AssetRegisterFetchedForEdit: (state, action) => {


            state.actionsLoading = false;
            state.userForEdit = action.payload.userForEdit;
            state.error = null;
        },
        AssetAssignmentListFetched: (state, action) => {
            const assignmentList = action.payload.data?.data.rows;


            state.actionsLoading = false;
            state.assignmentList = assignmentList;
            state.error = null;
        },


        AssetRegisterDeleted: (state, action) => {

            state.error = null;
            state.actionsLoading = false;


            state.entities = state.entities.filter(
                (el) => el.Id !== action.payload.Id
            );
        },





        assetRegisterCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;


            state.entities.unshift(action.payload);
        },




        assetRegisterUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
            // state.entities.push(action.payload)


            state.entities = state.entities.map((entity) => {

                //const payload = { ...action.payload };
                let payload = JSON.stringify(action.payload)
                let payloadObj = JSON.parse(payload);
                let finalObj = JSON.parse(payloadObj.updatedAssetRegister);
                if (entity.Id === finalObj.Id) {
                    return finalObj; //action.payload.updatedAssetRegister;
                }
                return entity;
            });

        },





    },
});
